module.exports = __webpack_public_path__ + "img/amazing-you.efaf0fbb.jpg";